import { environmentBase } from '@environments/config';
import { Environment } from '@environments/model';
import { LogLevel } from '@shared/services/logs';

export const environment: Environment = {
  ...environmentBase,
  production: false,
  isCacheEnabled: false,
  isMockEnabled: false,
  applicationType: 'TEST',
  logLevel: LogLevel.INFO,
  devTools: 'query',
  API: {
    ...environmentBase.API,
    endpoint: {
      ...environmentBase.API.endpoint,
      default: 'https://api.evoq-test.fourniergroupe.com/api/v1',
      evoqAdmin: 'https://admin.evoq-test.fourniergroupe.com/api/v1',
    },
  },
  tenants: {
    FRANCHISE: {
      authorizationEndpoint:
        'https://login.microsoftonline.com/c9fca1fb-f52e-4607-be25-910ae91ad780/oauth2/v2.0/authorize',
      clientId: '9f44b148-2a81-454a-9695-e14a4c11a3e4',
    },
    GROUPE: {
      authorizationEndpoint:
        'https://login.microsoftonline.com/b84fabbe-c9cd-4e94-b1a7-cb953f3b7227/oauth2/v2.0/authorize',
      clientId: 'e88f7eaf-5ce6-4993-b97e-dfae0e2da7bb',
    },
  },
  CDN: {
    url: 'https://assets-staging.evoq.fourniergroupe.com',
    rewrites: {
      images: {
        source: 'generated-images',
        target: 'evoq-images.test',
      },
      videos: {
        source: 'generated-videos',
        target: 'evoq-videos.test',
      },
    },
  },
  domains: {
    'evoq-test.perene.fr': {
      brand: 'perene',
      language: { default: 'fr', supported: ['fr'] },
    },
    'evoq-test.socooc.com': {
      brand: 'socooc',
      language: { default: 'fr', supported: ['fr'] },
    },
    'evoq-test.socooc.es': {
      brand: 'socooc',
      language: { default: 'es', supported: ['es', 'ca'] },
    },
    'evoq-test.mobalpa.fr': {
      brand: 'mobalpa',
      language: { default: 'fr', supported: ['fr'] },
    },
    'evoq-test.mobalpa.be': {
      brand: 'mobalpa',
      language: { default: 'fr-BE', supported: ['fr-BE', 'nl-BE'] },
    },
    'evoq-test.mobalpa.es': {
      brand: 'mobalpa',
      language: { default: 'es', supported: ['es', 'ca'] },
    },
    'evoq-test.hygena.com': {
      brand: 'hygena',
      language: { default: 'fr', supported: ['fr'] },
    },
  },
};
